import {
  Box,
  Typography,
  TextField,
  Button,
  Grid,
  Card,
  CardContent,
  Container,
} from "@mui/material";
import React, { useState } from "react";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Submitted", formData);
  };

  return (
    <Container
      maxWidth="lg" // Slightly wider container for better spacing
      sx={{
        // py: { xs: 4, md: 8 },
        fontFamily: "'Poppins', sans-serif",
        // background: "linear-gradient(180deg, #E6F0FA 0%, #F6F9FC 100%)", // Soft gradient background
        // background: "linear-gradient(180deg, #FFEBC1 0%, #FFD59A 0%)"
      }}
    >
      <Box
        id="contact-form"
        sx={{
          padding: "50px",
          // background: "#fff",
          borderRadius: 4,
          background: "rgba(255, 255, 255, 0.9)", // Semi-transparent white for a clean look
          backdropFilter: "blur(10px)", // Glassmorphism effect
          boxShadow: "0 8px 32px rgba(8, 226, 175, 0.1)",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Card
          sx={{
            maxWidth: 900,
            width: "100%",
            borderRadius: 3,
            padding: "30px",
            border: "1px solid",
            borderColor: "grey.300",
          }}
          elevation={0}
        >
          <CardContent>
            <Typography
              variant="h4"
              sx={{
                fontWeight: "bold",
                marginBottom: "30px",
                textAlign: "center",
                color: "#6a11cb",
              }}
            >
              Contact Us
            </Typography>

            <Grid container spacing={12}>
              {/* Left Column: Contact Information & Class Schedule */}

              {/* Right Column: Contact Form & QR Code */}
              <Grid item xs={12} md={12}>
                <form onSubmit={handleSubmit}>
                  <TextField
                    fullWidth
                    label="Name"
                    variant="outlined"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    sx={{ marginBottom: "15px" }}
                  />
                  <TextField
                    fullWidth
                    label="Email"
                    variant="outlined"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    type="email"
                    required
                    sx={{ marginBottom: "15px" }}
                  />
                  <TextField
                    fullWidth
                    label="Subject"
                    variant="outlined"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    sx={{ marginBottom: "15px" }}
                  />
                  <TextField
                    fullWidth
                    label="Message"
                    variant="outlined"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    multiline
                    rows={4}
                    required
                    sx={{ marginBottom: "20px" }}
                  />
                  <Box sx={{ textAlign: "center" }}>
                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: "#6a11cb",
                        color: "#fff",
                        fontWeight: "bold",
                        padding: "10px 20px",
                        borderRadius: "20px",
                        ":hover": { backgroundColor: "#5a09b6" },
                      }}
                      type="submit"
                    >
                      Send Message
                    </Button>
                  </Box>
                </form>

                {/* QR Code Scanner */}
                {/* <Box sx={{ textAlign: "center", marginTop: "30px" }}>
                <Typography sx={{ fontSize: "18px", fontWeight: "bold", marginBottom: "10px" }}>
                  Scan to Connect
                </Typography>
                <img src={QRCode} alt="QR Code Scanner" width={150} height={150} style={{ borderRadius: "10px", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)" }} />
              </Box> */}
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default ContactForm;
